module.exports = __webpack_public_path__ + "static/media/CORPORATION BANK.1a630bb1.svg";